export const requiredLength = 4
